import $ from 'jquery';
import AOS from 'aos';
import MicroModal from 'micromodal';
// import 'aos/dist/aos.css';

var testSectionPos;
var testSectionScrollTo;
var scrollAreaPos;
var faq2pgPos;
var faq3pgPos;
var faq4pgPos;
var faq5pgPos;
var faq2Pos;
var faq3Pos;
var faq4Pos;
var faq5Pos;

//////////////////////// ALL FUNCTIONS DEFINED ////////////////////////

// CONTACT MODAL
// $(".showContactModal").click(function(e) {
//   console.log('contact modal?');
//   // e.preventDefault();
//   $("#dialog1").addClass('showModal');
// });

//faq toggle stuff
$(".togglefaq").click(function(e) {
  console.log("togglefaq()");

  e.preventDefault();
  var notthis = $('.active').not(this);
  // notthis.find('.icon-minus').addClass('icon-plus').removeClass('icon-minus');
  notthis.toggleClass('active').next('.faqanswer').slideToggle(300);
  $(this).toggleClass('active').next().slideToggle("fast");
  // $(this).children('i').toggleClass('icon-plus icon-minus');
});

// CHECK IF TESTIMONIAL IS ON PAGE and SET VARIABLES
function testimonialCheckAndReset() {
  console.log("testimonialCheckAndReset()");

  if ($(".testimonials").length) {

    // console.log('testimonials exist');
    // Get positions of items within ScrollArea
    testSectionPos = $(".testimonials").offset().top;
    testSectionScrollTo = testSectionPos - 60;
    scrollAreaPos = $(".scrollArea").offset().top;
    faq2pgPos = $(".testimonialGroup#faq2").offset().top;
    faq3pgPos = $(".testimonialGroup#faq3").offset().top;
    faq4pgPos = $(".testimonialGroup#faq4").offset().top;
    faq5pgPos = $(".testimonialGroup#faq5").offset().top;
    faq2Pos = faq2pgPos - scrollAreaPos;
    faq3Pos = faq3pgPos - scrollAreaPos;
    faq4Pos = faq4pgPos - scrollAreaPos;
    faq5Pos = faq5pgPos - scrollAreaPos;
    // Make sure Testimonial ScrollArea is at beginning
    $('.scrollArea').scrollTop = 0;

    // console.log("testSectionPos: " + testSectionPos);
    console.log("testSectionScrollTo: " + testSectionScrollTo);
  }
}

// Center Testimonial Section
function centerTestimonialSection() {
  console.log("centerTestimonialSection()");

  if (window.innerWidth < 1250) {
    $("html").animate({
      scrollTop: scrollAreaPos + 'px'
    }, 500);
  } else {
    $("html").animate({
      scrollTop: testSectionScrollTo + 'px'
    }, 500);
  }
  // console.log("testSectionScrollTo: " + testSectionScrollTo);
}

function testimonialClickScroll() {

  console.log("testimonialClickScroll()");

  // center the Testimonial section on the page
  centerTestimonialSection();

  let href = $(this).attr("href");
  let scrollTarget = ".testimonialItem" + href;

  switch(scrollTarget) {
    case '.testimonialItem#faq1':
      $('.scrollArea').animate({
        scrollTop: 0 + 'px'
      }, 500);
      break;
    case '.testimonialItem#faq2':
      $('.scrollArea').animate({
        scrollTop: faq2Pos + 'px'
      }, 500);
      break;
    case '.testimonialItem#faq3':
      $('.scrollArea').animate({
        scrollTop: faq3Pos + 'px'
      }, 500);
      break;
    case '.testimonialItem#faq4':
      $('.scrollArea').animate({
        scrollTop: faq4Pos + 'px'
      }, 500);
      break;
    case '.testimonialItem#faq5':
      $('.scrollArea').animate({
        scrollTop: faq5Pos + 'px'
      }, 500);
      break;
    default:
      break;
  }
};



//////////////////////// ON-LOAD FUNCTIONS ////////////////////////
$(document).ready(function($) {
  console.log("doc ready");

  // On Load Function Calls
  testimonialCheckAndReset();
  // contactDialog.showModal();


  ////////////////// ALWAYS-ON SMOOTH SCROLL
  // Scrollbar.init($("#my-scrollbar"));

  // AOS library init
  AOS.init({
   // disable: mobile,
   offset: 200,
   delay: 50,
   duration: 500
  });

  // Micromodal plugin init
  MicroModal.init();

  const pageTopNav = $(".pageTopNav");


  //////////////////////// SCROLL ACTION FUNCTIONS ////////////////////////
  // $(document).scroll(function() {
  //   // console.log("scrolling");
  // });


  //////////////////////// WINDOW RESIZE FUNCTIONS ////////////////////////
  window.onresize = function() {
    console.log("windowResized");

    testimonialCheckAndReset();
  };

  //////////////////////// SMOOTH SCROLL - TESTIMONIAL LINKS
  $("section.testimonials .testLinkContainer a").click(centerTestimonialSection, testimonialClickScroll);

  //////////////////////// SMOOTH SCROLL - ID LINKS
  $('.scrollLink').click(function(){
    $('html').animate({
        scrollTop: $( $(this).attr('href') ).offset().top - 70
    }, 500);
    return false;
  });


  //////////////////////// <1250px NAV MENU-ITEMS
  ///////////////// PAGE TOP NAV
  $('.pageTopNav .hamburgerContainer').click(function(){
    if ($(".pageTopNav .menu-items").hasClass("showSideNav")) {
      $(".pageTopNav .menu-items").removeClass("showSideNav");
      // $(".hamburgerContainer").removeClass("posFixed");
    } else {
      $(".pageTopNav .menu-items").addClass("showSideNav");
      // $(".hamburgerContainer").addClass("posFixed");
    }
  });

  ///////////////// NAV ON SCROLL
  $('.navOnScroll .hamburgerContainer').click(function(){
    if ($(".navOnScroll .menu-items").hasClass("showSideNav")) {
      $(".navOnScroll .menu-items").removeClass("showSideNav");
    } else {
      $(".navOnScroll .menu-items").addClass("showSideNav");
    }
  });

  accordionNav = $(function(){
  	$('.menu-toggle').click(function(e) {
    	e.preventDefault();
    	var toggleButton = $(this);
      var subMenu = toggleButton.next();

    	if (subMenu.hasClass('active')) {
        subMenu.slideToggle(400);
        subMenu.removeClass('active');
        toggleButton.removeClass('rotate');

        // toggleButton.next().removeClass('active');
    		// toggleButton.next().slideUp(400);
    		// toggleButton.removeClass('rotate');
  		 } else {
        subMenu.slideToggle(400);
        subMenu.addClass('active');
        toggleButton.addClass('rotate');


        // toggleButton.parent().parent().find('li .sub-menu').removeClass('active');
        // toggleButton.parent().parent().find('li .sub-menu').slideUp(400);
        // toggleButton.parent().parent().find('.menu-toggle').removeClass('rotate');
        // toggleButton.next().toggleClass('active');
        // toggleButton.next().slideToggle(400);
        // toggleButton.toggleClass('rotate');
  		}
  	});
  });





    //////////////////////// CONTACT MODAL FUNCTION
    // const contactDialogBtn = $(".contactDialogBtn");
    // $(contactDialogBtn).click(openContactDialog);
    //
    // function openContactDialog() {
    //   $(".modal_contact").addClass("showModal");
    // };


    // Custom open and close handeler
    // This also has an close via backdrop option
    // TODO Replace with the Fylgja Plugin `@fylgja/dialog-js` (name may change 😅)
    // function newDialog(id, button, backdrop = true) {
    //   const dialog = document.querySelector(id);
    //   const btn = document.querySelector(button);
    //
    //   if (!dialog) return;
    //   if (!btn) return;
    //
    //   if (typeof HTMLDialogElement !== "function") {
    //     dialogPolyfill.registerDialog(dialog);
    //   }
    //
    //   const dialogClose = (target, e, dialog) => {
    //     if (!e.target.closest(target)) return;
    //     dialog.close();
    //   };
    //
    //   const dialogCloseOnBackdrop = (e, dialog) => {
    //     const rect = dialog.getBoundingClientRect();
    //     const isInDialog =
    //       rect.top <= e.clientY &&
    //       e.clientY <= rect.top + rect.height &&
    //       rect.left <= e.clientX &&
    //       e.clientX <= rect.left + rect.width;
    //
    //     if (!isInDialog) {
    //       dialog.close();
    //     }
    //   };
    //
    //   btn.addEventListener("click", () => {
    //       if (backdrop) {
    //           dialog.showModal();
    //       } else {
    //           dialog.show();
    //       }
    //   });
    //
    //   dialog.addEventListener("click", (e) => {
    //       dialogClose(".close", e, dialog);
    //       dialogCloseOnBackdrop(e, dialog);
    //   });
    // }
    //
    // newDialog("#dialog-modal", "#show-dialog-modal");





});








  ////////////////// EXPANDING LISTS
  // var coll = document.getElementsByClassName("accordion");
  // var i;
  //
  // for (i = 0; i < coll.length; i++) {
  //   coll[i].addEventListener("click", function() {
  //     this.classList.toggle("activetoggle");
  //     var content = this.nextElementSibling;
  //     if (content.style.display === "block") {
  //       content.style.display = "none";
  //     } else {
  //       content.style.display = "block";
  //     }
  //   });
  // }
// });
